<template>
	<div>
		<svg :width="size" :height="size" viewBox="0 0 25 25" :fill="color" xmlns="http://www.w3.org/2000/svg">
			<g id="Icon">
				<path id="Combined-Shape" fill-rule="evenodd" clip-rule="evenodd" d="M18.9327 14.3292C20.8743 12.6341 21.002 9.98893 19.2261 8.24189C17.5231 6.56663 14.7322 6.60433 12.9119 8.32868C11.5932 9.57797 10.2779 10.8306 8.95743 12.0783C8.61032 12.4062 8.27336 12.7498 7.89019 13.0361C7.07159 13.648 5.94463 13.7048 5.0879 13.1926C4.22648 12.6778 3.79555 11.9215 3.88562 10.9577C3.97329 10.0194 4.49319 9.32455 5.42369 8.96755C6.38795 8.59764 7.2952 8.74367 8.05933 9.41876C8.40108 9.72069 8.66564 10.1014 8.9163 10.39C9.49166 9.88565 9.92221 9.50828 10.3503 9.13296C8.54322 6.85015 5.74666 6.33689 3.67041 7.89838C2.7001 8.62806 2.13511 9.58797 2.02148 10.7527C1.87629 12.2411 2.47203 13.4646 3.66361 14.4345C2.53467 15.4021 1.94569 16.5443 2.02523 17.9753H3.82753C4.06114 16.2396 4.94243 15.3217 6.38189 15.3024C6.99135 15.2942 7.54051 15.4726 8.01411 15.8377C8.72227 16.3836 9.00941 17.1132 8.98063 17.9684H10.8223C10.8949 16.4898 10.271 15.3381 9.17677 14.4289C10.9265 12.751 12.6274 11.0758 14.3827 9.45325C15.4238 8.49083 16.9955 8.56709 17.9414 9.53517C18.8564 10.4717 18.82 11.9707 17.8605 12.8562C16.8595 13.7801 15.3301 13.7576 14.295 12.7938C14.0064 12.525 13.7449 12.2301 13.47 11.9462C12.9836 12.4151 12.5631 12.8203 12.1154 13.2518C12.5186 13.6211 12.9389 14.0061 13.3679 14.3989C12.1994 15.3519 11.5966 16.5073 11.6806 18H12.5956H13.4955C13.5961 16.3773 14.5494 15.3576 15.9588 15.3017C17.4446 15.2427 18.3454 16.1247 18.6629 17.9684H20.458C20.543 16.5191 19.9439 15.3859 18.8373 14.4398C18.8914 14.3765 18.9091 14.3498 18.9327 14.3292ZM20.5147 7.49672H20.8856V8.44002H21.0448V7.49672H21.4175V7.36937H20.5147V7.49672ZM22.924 7.32469H22.7232L22.5061 7.88579C22.4518 8.03204 22.4084 8.15944 22.3776 8.27643H22.3722C22.3415 8.15596 22.2999 8.0286 22.2492 7.88579L22.0411 7.32469H21.8404L21.7553 8.48468H21.9055L21.938 7.98728C21.9489 7.81347 21.9579 7.61898 21.9615 7.47443H21.9652C21.9995 7.61214 22.0484 7.76183 22.1063 7.92533L22.3035 8.4778H22.4229L22.6382 7.91501C22.6997 7.75495 22.7504 7.6104 22.7919 7.47443H22.7974C22.7956 7.61898 22.8064 7.81347 22.8155 7.97527L22.8463 8.48468H23L22.924 7.32469Z" fill="black"/>
			</g>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgAttachment',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null
		}
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		}
	}
};
</script>

<style scoped></style>